export function BrowseAllIcon(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 41}
      height={props.height ?? 40}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <rect
        x="9.5"
        y="9"
        width="9.56522"
        height="9.56522"
        rx="2"
        fill="currentColor"
      />
      <rect
        x="9.5"
        y="21.4348"
        width="9.56522"
        height="9.56522"
        rx="2"
        fill="currentColor"
      />
      <rect
        x="21.9346"
        y="9"
        width="9.56522"
        height="9.56522"
        rx="2"
        fill="currentColor"
      />
      <rect
        x="21.9346"
        y="21.4348"
        width="9.56522"
        height="9.56522"
        rx="2"
        fill="currentColor"
      />
    </svg>
  );
}

export function ArrowRight(props: {
  class?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
}) {
  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M19 12H5"
        stroke="currentColor"
        stroke-width={props.strokeWidth ?? 1.5}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 7L19 12"
        stroke="currentColor"
        stroke-width={props.strokeWidth ?? 1.5}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 17L19 12"
        stroke="currentColor"
        stroke-width={props.strokeWidth ?? 1.5}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CaretDown(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 20}
      height={props.height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M13.3337 8.33329L10.0003 11.6666L6.66699 8.33329"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CaretRight(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 28}
      height={props.height ?? 28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M11.6663 9.33325L16.333 13.9999L11.6663 18.6666"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CaretLeft(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 28}
      height={props.height ?? 28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M16.3337 9.33325L11.667 13.9999L16.3337 18.6666"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CaretUp(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 20}
      height={props.height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M6.66634 11.6667L9.99967 8.33337L13.333 11.6667"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function MagnifyingGlass(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 20}
      height={props.height ?? 21}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M17.7431 19.3032C18.036 19.5961 18.5108 19.5961 18.8037 19.3032C19.0966 19.0103 19.0966 18.5355 18.8037 18.2426L17.7431 19.3032ZM14.6035 9.04005C14.6035 12.3886 11.889 15.1031 8.54054 15.1031V16.6031C12.7175 16.6031 16.1035 13.217 16.1035 9.04005H14.6035ZM8.54054 15.1031C5.19204 15.1031 2.47754 12.3886 2.47754 9.04005H0.977539C0.977539 13.217 4.36361 16.6031 8.54054 16.6031V15.1031ZM2.47754 9.04005C2.47754 5.69155 5.19204 2.97705 8.54054 2.97705V1.47705C4.36361 1.47705 0.977539 4.86312 0.977539 9.04005H2.47754ZM8.54054 2.97705C11.889 2.97705 14.6035 5.69155 14.6035 9.04005H16.1035C16.1035 4.86312 12.7175 1.47705 8.54054 1.47705V2.97705ZM12.8766 14.4368L17.7431 19.3032L18.8037 18.2426L13.9373 13.3761L12.8766 14.4368Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CopyIcon(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 26}
      height={props.height ?? 27}
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M21.9363 19.1866V6.18652C21.9363 5.28906 21.2087 4.56152 20.3113 4.56152H7.31055"
        stroke="currentColor"
        stroke-width="1.625"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.0611 7.81152H5.68555C4.78808 7.81152 4.06055 8.53906 4.06055 9.43652V20.8115C4.06055 21.709 4.78808 22.4365 5.68554 22.4365H17.0611C17.9586 22.4365 18.6861 21.709 18.6861 20.8115V9.43652C18.6861 8.53906 17.9586 7.81152 17.0611 7.81152Z"
        stroke="currentColor"
        stroke-width="1.625"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ShareIcon(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M8.55286 10.1142C9.59439 11.1557 9.59439 12.8443 8.55286 13.8859C7.51133 14.9274 5.82268 14.9274 4.78115 13.8859C3.73962 12.8443 3.73962 11.1557 4.78115 10.1142C5.82268 9.07263 7.51133 9.07263 8.55286 10.1142"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.2189 4.78115C20.2604 5.82268 20.2604 7.51133 19.2189 8.55286C18.1773 9.59439 16.4887 9.59439 15.4472 8.55286C14.4056 7.51133 14.4056 5.82268 15.4472 4.78115C16.4887 3.73962 18.1773 3.73962 19.2189 4.78115"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.2189 15.4472C20.2604 16.4887 20.2604 18.1773 19.2189 19.2189C18.1773 20.2604 16.4887 20.2604 15.4472 19.2189C14.4056 18.1773 14.4056 16.4887 15.4472 15.4472C16.4887 14.4056 18.1773 14.4056 19.2189 15.4472"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.03906 10.8096L14.9591 7.84961"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.03906 13.1904L14.9591 16.1504"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function EmailIcon(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 20}
      height={props.height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M6.24902 8.12402L8.68793 9.62768C9.4927 10.1238 10.5085 10.1238 11.3132 9.62768L13.7521 8.12402"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="2.49707"
        y="4.16406"
        width="15.0062"
        height="11.6715"
        rx="3"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function MapLocationIcon(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 20}
      height={props.height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M10.2946 5.6402C10.4571 5.80277 10.4571 6.06704 10.2946 6.22961C10.132 6.39218 9.86771 6.39218 9.70514 6.22961C9.54257 6.06704 9.54257 5.80277 9.70514 5.6402C9.86771 5.47763 10.1312 5.47763 10.2946 5.6402"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5927 6.02055V6.02055C13.5927 6.99679 13.1592 7.92134 12.4097 8.5466L11.2317 9.52868C10.7624 9.92051 10.4114 10.4349 10.218 11.0151L9.99956 11.6671L9.78197 11.0143C9.58855 10.4349 9.23757 9.91967 8.76821 9.52784L7.59022 8.54577C6.83991 7.92051 6.40723 6.99596 6.40723 6.01972V6.01972V6.03806C6.40639 3.79712 8.263 0.977539 9.99956 0.977539C11.7361 0.977539 13.5927 3.79712 13.5927 6.03889"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.99865 9.99951C4.20415 9.99951 3.5197 10.5606 3.3638 11.3401L2.53012 15.5085C2.32337 16.5397 3.11286 17.5026 4.16497 17.5026H15.8357C16.8878 17.5026 17.6773 16.5397 17.4705 15.5085L16.6368 11.3401C16.4809 10.5606 15.7965 9.99951 15.002 9.99951"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function InstagramIcon(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <rect width="24" height="24" rx="12" fill="currentColor" />
      <path
        d="M12.0002 5.28459C14.1866 5.28459 14.4458 5.29179 15.3098 5.33259C16.109 5.36859 16.5434 5.50299 16.8314 5.61579C17.213 5.76459 17.4866 5.94219 17.7722 6.22779C18.0578 6.51339 18.2354 6.78699 18.3842 7.16859C18.497 7.45659 18.629 7.89099 18.6674 8.69019C18.7058 9.55419 18.7154 9.81339 18.7154 11.9998C18.7154 14.1862 18.7082 14.4454 18.6674 15.3094C18.6314 16.1086 18.497 16.543 18.3842 16.831C18.2354 17.2126 18.0578 17.4862 17.7722 17.7718C17.4866 18.0574 17.213 18.235 16.8314 18.3838C16.5434 18.4966 16.109 18.6286 15.3098 18.667C14.4458 18.7054 14.1866 18.715 12.0002 18.715C9.81384 18.715 9.55464 18.7078 8.69064 18.667C7.89144 18.631 7.45704 18.4966 7.16904 18.3838C6.78744 18.235 6.51384 18.0574 6.22824 17.7718C5.94264 17.4862 5.76504 17.2126 5.61624 16.831C5.50344 16.543 5.37144 16.1086 5.33304 15.3094C5.29464 14.4454 5.28504 14.1862 5.28504 11.9998C5.28504 9.81339 5.29224 9.55419 5.33304 8.69019C5.36904 7.89099 5.50344 7.45659 5.61624 7.16859C5.76504 6.78699 5.94264 6.51339 6.22824 6.22779C6.51384 5.94219 6.78744 5.76459 7.16904 5.61579C7.45704 5.50299 7.89144 5.37099 8.69064 5.33259C9.55464 5.29179 9.81384 5.28459 12.0002 5.28459ZM12.0002 3.80859C9.77544 3.80859 9.49704 3.81819 8.62344 3.85899C7.75224 3.89979 7.15704 4.03659 6.63384 4.24059C6.09624 4.44699 5.63784 4.72779 5.18424 5.18379C4.72824 5.63979 4.44984 6.09579 4.23864 6.63579C4.03704 7.15659 3.89784 7.75179 3.85704 8.62539C3.81624 9.49899 3.80664 9.77739 3.80664 12.0022C3.80664 14.227 3.81624 14.5054 3.85704 15.379C3.89784 16.2502 4.03464 16.8454 4.23864 17.3686C4.44744 17.9038 4.72824 18.3622 5.18424 18.8158C5.64024 19.2718 6.09624 19.5502 6.63624 19.7614C7.15704 19.963 7.75224 20.1022 8.62584 20.143C9.49944 20.1838 9.77784 20.1934 12.0026 20.1934C14.2274 20.1934 14.5058 20.1838 15.3794 20.143C16.2506 20.1022 16.8458 19.9654 17.369 19.7614C17.9042 19.5526 18.3626 19.2718 18.8162 18.8158C19.2722 18.3598 19.5506 17.9038 19.7618 17.3638C19.9634 16.843 20.1026 16.2478 20.1434 15.3742C20.1842 14.5006 20.1938 14.2222 20.1938 11.9974C20.1938 9.77259 20.1842 9.49419 20.1434 8.62059C20.1026 7.74939 19.9658 7.15419 19.7618 6.63099C19.553 6.09579 19.2722 5.63739 18.8162 5.18379C18.3602 4.72779 17.9042 4.44939 17.3642 4.23819C16.8434 4.03659 16.2482 3.89739 15.3746 3.85659C14.5034 3.81819 14.225 3.80859 12.0002 3.80859Z"
        fill="white"
      />
      <path
        d="M12.0002 7.79297C9.67697 7.79297 7.79297 9.67697 7.79297 12.0002C7.79297 14.3234 9.67697 16.2074 12.0002 16.2074C14.3234 16.2074 16.2074 14.3234 16.2074 12.0002C16.2074 9.67697 14.3234 7.79297 12.0002 7.79297ZM12.0002 14.7314C10.493 14.7314 9.26897 13.5098 9.26897 12.0002C9.26897 10.4906 10.493 9.26897 12.0002 9.26897C13.5074 9.26897 14.7314 10.4906 14.7314 12.0002C14.7314 13.5098 13.5074 14.7314 12.0002 14.7314Z"
        fill="white"
      />
      <path
        d="M16.3727 8.61107C16.9161 8.61107 17.3567 8.17051 17.3567 7.62707C17.3567 7.08362 16.9161 6.64307 16.3727 6.64307C15.8292 6.64307 15.3887 7.08362 15.3887 7.62707C15.3887 8.17051 15.8292 8.61107 16.3727 8.61107Z"
        fill="white"
      />
    </svg>
  );
}

export function FacebookIcon(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <rect width="24" height="24" rx="12" fill="currentColor" />
      <path
        d="M16.6711 15.4687L17.2031 12H13.875V9.74906C13.875 8.80008 14.34 7.875 15.8306 7.875H17.3437V4.92187C17.3437 4.92187 15.9705 4.6875 14.6576 4.6875C11.9166 4.6875 10.125 6.34875 10.125 9.35625V12H7.07812V15.4687H10.125V23.8542C10.736 23.9501 11.362 24 12 24C12.638 24 13.264 23.9501 13.875 23.8542V15.4687H16.6711Z"
        fill="white"
      />
    </svg>
  );
}

export function TwitterIcon(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <rect width="24" height="24" rx="12" fill="currentColor" />
      <path
        d="M9.21608 18.0958C14.8753 18.0958 17.9737 13.4062 17.9737 9.33822C17.9737 9.20622 17.9737 9.07182 17.9641 8.93982C18.5665 8.50302 19.0873 7.96542 19.5001 7.34622C18.9385 7.59582 18.3433 7.75902 17.7337 7.83102C18.3769 7.44702 18.8569 6.84222 19.0873 6.12942C18.4825 6.48702 17.8225 6.74142 17.1337 6.87582C15.9673 5.63742 14.0185 5.57742 12.7801 6.74142C11.9809 7.49262 11.6425 8.61342 11.8897 9.68142C9.41528 9.55662 7.10888 8.38782 5.54648 6.46542C4.73048 7.87182 5.14568 9.66942 6.49928 10.5742C6.00968 10.5598 5.52968 10.4278 5.10248 10.1902C5.10248 10.2022 5.10248 10.2166 5.10248 10.2286C5.10248 11.6926 6.13448 12.955 7.57208 13.2454C7.11848 13.3678 6.64328 13.387 6.18248 13.2982C6.58568 14.551 7.74008 15.4102 9.05768 15.4366C7.96808 16.2934 6.62168 16.759 5.23688 16.7566C4.99208 16.7566 4.74728 16.7422 4.50488 16.711C5.90648 17.6158 7.54568 18.0958 9.21608 18.0934"
        fill="white"
      />
    </svg>
  );
}

export function CloseIcon(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M18 6L6 18M18 18L6 6.00001"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function MenuIcon(props: {
  class?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="6" y="7" width="16" height="2" rx="1" fill="currentColor" />
      <rect x="6" y="13" width="16" height="2" rx="1" fill="currentColor" />
      <rect x="6" y="19" width="16" height="2" rx="1" fill="currentColor" />
    </svg>
  );
}
